// extracted by mini-css-extract-plugin
export var content = "PostItem-module--content--RyW9c";
export var item = "PostItem-module--item--ci-gf";
export var title = "PostItem-module--title--dyAxr";